const destinations = [
  {
    name: "Guatemala & Honduras",
    context: "Church mission trips from Broken Arrow, Bixby, and Jenks evangelical communities. Youth groups and adult teams serve in rural villages and urban ministry centers.",
    urgency: "Group rosters finalized 4–6 weeks before departure — passport issues discovered late",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Cancun & Riviera Maya",
    context: "Family beach vacations, spring break trips from NSU-BA students, and corporate retreats from BA professionals. Direct charters from TUL.",
    urgency: "Last-minute Cancun charters and cruise bookings peak March through August",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Jamaica & Caribbean",
    context: "Caribbean destination popular with Broken Arrow families. All-inclusive resorts near Montego Bay and Negril are favorites for BA vacationers.",
    urgency: "Holiday cruise bookings spike in November — many discover expired passports then",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Italy & Europe",
    context: "Broken Arrow couples and families travel to Italy for cultural tours, anniversary trips, and heritage travel. European cruises also popular with retirees.",
    urgency: "Summer European vacations booked 3–4 months ahead, but passport renewals often delayed",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Costa Rica",
    context: "Eco-tourism and mission trips to Costa Rica are popular from Broken Arrow. Rainforest tours, zip-lining, and wildlife sanctuaries draw BA families.",
    urgency: "Spring break and summer family trips create predictable March–July demand",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Ski trips to Banff and Calgary, and weekend trips to Toronto. Also popular for BA business professionals visiting Canadian partners.",
    urgency: "Winter ski season peaks December through February",
    icon: "ri-map-pin-2-line",
  },
];

const commonSituations = [
  {
    stat: "60%",
    label: "of Broken Arrow expedited requests involve church mission trips or family vacation travel",
  },
  {
    stat: "3–6 Weeks",
    label: "average notice Broken Arrow church groups have before a mission trip departure",
  },
  {
    stat: "June–Aug",
    label: "peak season when mission trips, youth camps, and family vacations collide",
  },
  {
    stat: "72 Hours",
    label: "shortest turnaround we have accommodated for a BA business professional with a Toronto conference",
  },
];

export default function BrokenArrowDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Broken Arrow Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Broken Arrow and Tulsa east metro clients. Understanding local travel behavior is part of why our document review catches issues before they derail your mission trip, family vacation, or business conference.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Oklahoma Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Oklahoma with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/cities/tulsa" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Tulsa <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/oklahoma-city" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Oklahoma City <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/norman" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Norman <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}